module.exports = __webpack_public_path__ + "static/img/6areaA_7.216b7ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/6areaA_7.png
// module id = 909
// module chunks = 1